'use strict';

import createSlot from "../helpers/createSlot";
import ActionButton from "./userflight/common/ActionButton";
import { timeLongFormat } from "~/helpers/strings";
import Image from "./Image";

export const ButtonSlot = createSlot()
export const PriceSlot = createSlot()
export const AfterPriceSlot = createSlot()
export const NotesSlot = createSlot()
export const TermsSlot = createSlot()
export const FormSlot = createSlot()

export default function OfferDetail({
    item,
    onActionPress,
    imageSize = undefined,

    children
}) {
    const {id, aircraft, routes, prices, tags, notes, actions} = item
    const sliderRef = React.useRef()
    const sliderPaginationRef = React.useRef()
    const sliderPrevRef = React.useRef()
    const sliderNextRef = React.useRef()
    
    React.useEffect(() => {
        if (sliderRef.current && sliderPaginationRef.current && sliderPrevRef.current && sliderNextRef.current) {
            new Swiper(sliderRef.current, {
                pagination: {
                    el: sliderPaginationRef.current,
                },
                navigation: {
                    nextEl: sliderNextRef.current,
                    prevEl: sliderPrevRef.current,
                }
            });
        }
    }, [id])

    let departDate, departDateFrom, departDateTo = null;
    if (routes && routes.length > 0 && routes[0]) {
        departDate = routes[0].departDate
        departDateFrom = routes[0].departDateFrom
        departDateTo = routes[0].departDateTo
    }

    const images = imageSize && aircraft.images && aircraft.images[imageSize] ? aircraft.images[imageSize] : []

    return <React.Fragment>
        <div className="offer-modal__row">
            <div className="offer-modal__desc">
                <div className="offer-modal__top">
                    <div>
                        <h3 className="offer-modal__title">{aircraft.title}</h3>
                        <div className="offer-modal__info">
                            {!!aircraft.year && <span>{aircraft.year}</span>}
                            <span>{aircraft.class.title}</span>
                        </div>
                        {tags && tags.length > 0 && <div className="offer-modal__tags">
                            {tags.map(tag => <span key={`tags-${tag.label}`} >{tag.label}</span>)}
                        </div>}
                    </div>
                    <div className="offer-modal__sheme">
                        <Image src={aircraft.class.image.url} alt={aircraft.title} />
                    </div>
                </div>
                <div className="offer-modal__center">
                    <ul className="offer-modal__list">
                        <AircraftParameter title={tMsg('Питание')} value={aircraft.facilities.food.label} />
                        <AircraftParameter title={tMsg('Стюардесса')} value={aircraft.facilities.stewardess.label} />
                        <AircraftParameter title={tMsg('Интернет')} value={aircraft.facilities.internet.label} />
                        <AircraftParameter title={tMsg('WC')} value={aircraft.facilities.toilet.label} />
                        <AircraftParameter title={tMsg('Курение')} value={aircraft.facilities.smoke.label} />
                        <AircraftParameter title={tMsg('VIP-терминал')} value={aircraft.facilities.vip.label} />
                    </ul>
                    <ul className="offer-modal__list">
                        <AircraftParameter title={tMsg('Места')} value={aircraft.params.seats.value} />
                        <AircraftParameter title={tMsg('Высота салона')} value={aircraft.params.height.value} unit={aircraft.params.height.units} />
                        <AircraftParameter title={tMsg('Ширина салона')} value={aircraft.params.width.value} unit={aircraft.params.width.units} />
                        <AircraftParameter title={tMsg('Длина салона')} value={aircraft.params.length.value} unit={aircraft.params.length.units} />
                        <AircraftParameter title={tMsg('Объем багажника')} value={aircraft.params.trunk.value} unit={aircraft.params.trunk.units} />
                        {!!aircraft.update && <AircraftParameter title={tMsg('Обновление салона')} value={aircraft.params.update_year.value} unit={aircraft.params.update_year.units} />}
                    </ul>
                </div>
            </div>
            {images.length > 0 && <div className="offer-modal__slider">
                <div ref={sliderRef} className="swiper">
                    <div className="swiper-wrapper">
                        {images.map((image, index) => {
                            return <div key={`images${id}${index}`} className="swiper-slide">
                                <Image src={image} alt=""/>
                            </div>
                        })}
                    </div>
                </div>
                <div ref={sliderNextRef} className="swiper-button-next"></div>
                <div ref={sliderPrevRef} className="swiper-button-prev"></div>
                {images.length > 1 && <div ref={sliderPaginationRef} className="swiper-pagination"></div>}
            </div>}
            {images.length === 0 && <div className="offer-modal__slider" style={{alignSelf: 'center', padding: '6em'}}>
                <div ref={sliderRef} className="swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <Image src={undefined} alt=""/>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
        <div className="offer-modal__bottom">

            {routes.length === 1 && routes.map((route, index) => <RouteCard key={`route${index}`} route={route} index={1} />)}
            {routes.length > 1 && <RouteCards routes={routes} />}

            <div className="offer-modal__control">
                <div className="offer-control__text">

                    <NotesSlot.Renderer childs={ children }>
                        {notes && <React.Fragment>
                            { notes.length > 200 && <React.Fragment>{notes.slice(0, 200)}...&nbsp;<a href="#full-text" data-fancybox>{__('userflight.notes.fullText')}</a></React.Fragment>}
                            { notes.length <= 200 && <React.Fragment>{notes}</React.Fragment>}
                        </React.Fragment>}
                        
                        <div id="full-text" className="text-modal" style={{display: 'none'}}>
                            <h3>{__('modal.pdf.comment')}</h3>
                            <p>{notes}</p>
                        </div>
                    </NotesSlot.Renderer>

                    <TermsSlot.Renderer childs={ children }>
                        <div className="offer-control__text">
                            <a href="#termsModalNoButton" data-fancybox className="offer-control__link">
                                {tMsg('Условия бронирования и отмены рейса')}
                            </a>
                        </div>
                    </TermsSlot.Renderer>

                </div>

                <div className="offer-control__bottom">
                    <div className="offer-control__price">

                        <PriceSlot.Renderer childs={ children }>
                            <div className="offer-control__price-value">
                                { prices.prefix }{ prices.price.formatPrice ( prices.currency.code ) }
                            </div>
                            {prices.price_extra && <span>{tMsg('Доплата за пассажира')} — {prices.price_extra.formatPrice(prices.currency.code)}</span>}
                            {prices.price_extra_by_request && <span>{tMsg('Доплата за пассажира')} — {tMsg('По запросу')}</span>}
                        </PriceSlot.Renderer>

                        <AfterPriceSlot.Renderer childs={ children } />

                        <FormSlot.Renderer childs={ children } />

                    </div>

                    <div className="offer-control__btn flex-column mt-auto">
                        <ButtonSlot.Renderer childs={ children }>
                            {actions && actions.map(action => <ActionButton key={action.code}
                                action={action}
                                context="list"
                                onPress={options => onActionPress(action, options)} />)}
                        </ButtonSlot.Renderer>
                    </div>

                </div>
            </div>
        </div>
        
    </React.Fragment>
}

function AircraftParameter({ title, value, unit = undefined }) {
    if (!value)
        return null
    
    const formattedValue = isNaN(parseFloat(String(value))) ? value : String(value).replace('.', ',')
    return <li>
        <span>{title}</span>
        <span>{formattedValue} {unit}</span>
    </li>
    
}

const cardHeight = 140;

function RouteCard({
    route,
    isHovered = false,
    index = 0,
    count = 1,
    
    dateExtractor = item => window.moment(item.date || item.date_from, 'DD.MM.YYYY').format('D MMMM'),
    dateToExtractor = item => item.date_to ? window.moment(item.date_to, 'DD.MM.YYYY').format('D MMMM') : undefined,
    timeExtractor = item => item.time || item.time_from || undefined,
    timeToExtractor = item => item.time_to || undefined,
    flightTimeExtractor = item => item.flight_time ? timeLongFormat(item.flight_time) : undefined,
    
}) {
    const {from, to, seats} = route
    const isFirst = index === 0;

    const dateFrom = dateExtractor(route)
    const timeFrom = timeExtractor(route)
    const dateTo = dateToExtractor(route)
    const timeTo = timeToExtractor(route)
    const flightTime = flightTimeExtractor(route)

    const reverse = count - index;
    const translateY = isHovered ? reverse * -cardHeight : 0;
    
    return <div className={cn('direction-card', isFirst && 'first')} 
                style={{ 
                    transform: `translate(0, ${translateY}px)`, 
                    zIndex: count - index, 
                    top: isHovered ? 0 : index * 10 + 'px' 
                }}>
        <div className="direction-card__header">
            <div className="direction-card__date">
                {`${dateFrom} (${timeFrom}) ${!!dateTo ? '—' : ''}`}
                {!!dateTo && <br/>}
                {!!dateTo &&`${dateTo} (${timeTo})`}
            </div>
            <div className="direction-card__time">
                {flightTime}
            </div>
            {seats && <div className="direction-card__user">
                <span>
                    <i className="icon-user"></i>
                    {seats}
                </span>
            </div>}
        </div>
        <div className="direction-card__way">
            <div className="direction-card__code">{from.icao}</div>
            <div className="direction-card__line">
                <span></span>
                <div className="solid-left"></div>
                {isFirst && <span></span>}
                {!isFirst && <i className="icon-plane2"></i>}
                <div className="solid-right"></div>
                <span></span>
            </div>
            <div className="direction-card__code">{to.icao}</div>
        </div>
        <div className="direction-card__city">

            <div className="direction-card__sub">
                {tMsg('Время в пути')}
            </div>
            <div className="direction-card__city-from">
                {from.city && <span>{from.city + (from.airport ? ', ' : '')}</span>}
                {from.airport && <span>{from.airport}</span>}
            </div>
            <div className="direction-card__city-to">
                {to.city && <span>{to.city + (to.airport ? ', ' : '')}</span>}
                {to.airport && <span>{to.airport}</span>}
            </div>
        </div>
    </div>
}

function RouteCards({routes = []}) {
    
    const cardsWrapp = React.useRef()
    const cardsContainer = React.useRef()
    const routesTransformed = [routes[0], ...routes].map((route) => ({route}))
    const [isHovered, setIsHovered] = React.useState(false);
    
    const closedHeight = cardHeight + routes.length * 10;

    React.useEffect(() => {
        const handleMouseEnter = () => setIsHovered(() => true);
        const handleMouseLeave = () => setIsHovered(() => false);
        
        if (cardsContainer.current) {
            const $cardsWrapper = $(cardsContainer.current);
            $cardsWrapper.on('mouseenter', handleMouseEnter);
            $cardsWrapper.on('mouseleave', handleMouseLeave);
        }
        
        return () => {
            if (cardsContainer.current) {
                const $cardsWrapper = $(cardsContainer.current);
                $cardsWrapper.off('mouseenter', handleMouseEnter);
                $cardsWrapper.off('mouseleave', handleMouseLeave);
            }
        }
    }, [])
    
    if (routes.length === 0) 
        return null;
    
    return <div ref={cardsWrapp} className="offer-modal__cards-wrapp" 
                style={{ height: (closedHeight - 10) + 'px' }}>
        <div ref={cardsContainer}
             className={cn("offer-modal__cards", isHovered && 'open')}
             style={{ marginTop: isHovered ? (routes.length * 10) + 'px' : 0 }}>
            {routesTransformed.map(({route}, index) => <RouteCard key={`route${index}`} route={route} index={index} count={routes.length} isHovered={isHovered} />)}
        </div>
    </div>
}

